module.exports = {
  model: { id: '', name: '' },
}
